export const typeOfTaxonomyLookupModal = 'typeOfTaxonomyLookupModal';
export const taxonomyLookupModalReducerKey = 'taxonomyLookupModalReducerKey';

export const taxonomyLookupModalSetIsLoadingReducerType = 'taxonomyLookupModalSetIsLoadingReducerType';
export const taxonomyLookupModalSetSuggestConfigReducerType = 'taxonomyLookupModalSetSuggestConfigReducerType';
export const taxonomyLookupModalSetOpModelReducerType = 'taxonomyLookupModalSetOpModelReducerType';
export const taxonomyLookupModalSetBoundOperatorReducerType = 'taxonomyLookupModalSetBoundOperatorReducerType';
export const taxonomyLookupModalSetSearchReducerType = 'taxonomyLookupModalSetSearchReducerType';
export const taxonomyLookupModalSetSelectedItemsReducerType = 'taxonomyLookupModalSetSelectedItemsReducerType';
export const taxonomyLookupModalSetTotalHitCountReducerType = 'taxonomyLookupModalSetTotalHitCountReducerType';
export const taxonomyLookupModalSetTransferEnabledReducerType = 'taxonomyLookupModalSetTransferEnabledReducerType';

export const NUM_OF_SUGGESTIONS = 10;
